import Typography from '@mui/material/Typography';
import { useIntl } from '@mfw/components';

import messages from './messages';

// The fixed, platform-wide legal notice — shown wherever a marketplace
// Terms of Use is presented (the org's own edit form, and the buyer's
// acceptance dialog at checkout). Not editable per-org.
export const TermsOfUseDisclaimer = () => {
  const { formatMessage } = useIntl();
  return (
    <Typography
      data-testid="terms-of-use-disclaimer"
      variant="caption"
      color="text.secondary"
      display="block"
    >
      {formatMessage(messages.disclaimer)}
    </Typography>
  );
};

export default TermsOfUseDisclaimer;
